
import DatePicker from '@/components/DatePicker/DatePicker.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import DeliveryGoal from '@/models/DeliveryGoal'
import { ProductsAll } from '@/models/interface/Common'
import ViewModel from '@/models/ViewModel'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import { watch } from 'fs'
import moment from 'moment'
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator'
import SelectOption from '@/models/interface/SelectOption'
import Inventory from '@/models/Inventory'

@Component({
  components: {
    DatePicker,
    FormInput,
    IconAction,
    SelectPicker,
  },
})
export default class DeliveryGoals extends ViewModel {
  @Prop({ default: 'delivery_goals' })
  public type!: string

  @Prop()
  public value!: any // company.delivery_goals || company.delivery_caps

  public local_value: any = []

  public notificating: boolean = false

  public local_errors: any = []

  public report_name_options: SelectOption[] = []

  public inventory_group_options: SelectOption[] = []

  @Watch('local_value', { deep: true })
  public onLocalValueChange(value: any) {
    this.$emit('input', value)
    setTimeout(() => {
      this.checkForOverlaps()
    }, 500)
  }

  public get goals_dates() {
    return {
      ...this.local_value.map((v: any) => ({ ...v })),
    }
  }

  public get product_options() {
    return ProductsAll
  }

  public addDeliveryGoal() {
    let deliver: DeliveryGoal = new DeliveryGoal()
    this.local_value.push(deliver)
  }

  public remove(index: number) {
    this.local_value.splice(index, 1)
  }

  // Display the date range as a hint when the user hasn't typed a name yet.
  public goalNamePlaceholder(goal: any): string {
    if (!goal?.start_at || !goal?.end_at) {
      return ''
    }
    const start = moment(goal.start_at).format('MMM D, YYYY')
    const end = moment(goal.end_at).format('MMM D, YYYY')
    return `${start} – ${end}`
  }

  public get defaultToggleLabel(): string {
    return this.type === 'delivery_goals' ? 'Default for dashboard' : 'Default'
  }

  // Only one entry in each bag (goals or caps) can be the default per company.
  public onDefaultToggle(index: number, checked: boolean) {
    this.local_value.forEach((goal: any, i: number) => {
      goal.is_default = checked && i === index
    })
  }

  public mounted() {
    Inventory.loadReportNameOptions().then((o: any) => {
      this.report_name_options = o
      this.local_value = this.value
    })
    Inventory.loadInventoryGroupOptions().then((o: any) => {
      this.inventory_group_options = o
    })

    if (this.local_value.length) {
      setTimeout(() => {
        this.checkForOverlaps()
      }, 500)
    }
  }

  public notify(msg: any = 'Overlapping', title = '') {
    if (this.notificating) return
    this.notificating = true
    setTimeout(() => {
      this.notificating = false
    }, 6100)
    this.$snotify.error(msg, title, {
      id: 'notification',
      timeout: 6000,
      showProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      preventDuplicates: true,
      maxOnScreen: 1,
    })
  }

  public toggleErrors(index: any[], remove: boolean = false) {
    index.forEach((i: number) => {
      let card: any = this.$refs[`${this.type}_card_${i}`]

      if (card.length) card = card[0]
      else return

      let hasClass = card.classList.contains('border-danger')

      if (card && !hasClass) {
        card.classList.add('border', 'border-danger')
      }
      if (remove) {
        card.classList.remove('border-danger')
      }
    })
  }

  public addErrors(index: number, msg: any = ['Overlapping date']) {
    let s_date_vid = `delivery-start-${index}`
    let e_date_vid = `delivery-end-${index}`
    let error = {
      [s_date_vid]: msg,
      [e_date_vid]: msg,
    }
    this.$emit('errors', error)
  }

  public comparingRulesOrverlaps(goal: any, comparing_goal: any) {
    if (
      goal.start_at.isBetween(comparing_goal.start_at, comparing_goal.end_at)
      || goal.start_at.isSame(comparing_goal.start_at)
      || goal.end_at.isBetween(comparing_goal.start_at, comparing_goal.end_at)
      || (goal.end_at.isSame(comparing_goal.end_at)
        && comparing_goal.start_at.isBetween(goal.start_at, goal.end_at))
      || comparing_goal.end_at.isBetween(goal.start_at, goal.end_at)
      || comparing_goal.start_at.isSame(goal.start_at)
      || comparing_goal.end_at.isSame(goal.end_at)
    ) {
      return true
    }
    return false
  }

  public checkForOverlaps() {
    this.$emit('hasErrors', false)
  }
}
